// import React, { createContext, useContext, useEffect, useState } from "react";

// const AuthContext = createContext();

// export default function AuthContextProvider({ children }) {
//   const [authenticated, setAuthenticated] = useState(false);
//   const [currentUser, setCurrentUser] = useState();

//   useEffect(() => {
//     const storedAuth = JSON.parse(localStorage.getItem("authenticated"));
//     const storedUser = JSON.parse(localStorage.getItem("currentUser"));

//     if (storedAuth) {
//       setAuthenticated(storedAuth);
//     }
//     if (storedUser) {
//       setCurrentUser(storedUser);
//     }
//   }, []);

//   // Save authentication state and user to localStorage whenever they change
//   useEffect(() => {
//     const storedAuth = JSON.parse(localStorage.getItem('authenticated'));
//     const storedUser = JSON.parse(localStorage.getItem('currentUser'));

//     if (storedAuth) {
//       setAuthenticated(storedAuth);
//     }
//     if (storedUser) {
//       setCurrentUser(storedUser);
//     }
//   }, []);

//   // Save authentication state and user to localStorage whenever they change
//   useEffect(() => {
//     localStorage.setItem('authenticated', JSON.stringify(authenticated));
//     localStorage.setItem('currentUser', JSON.stringify(currentUser));
//   }, [authenticated, currentUser]);

//   const login = (user) => {
//     setAuthenticated(true);
//     setCurrentUser(user);
//   };

//   const logout = () => {
//     setAuthenticated(false);
//     setCurrentUser(null);
//     localStorage.removeItem('authenticated');
//     localStorage.removeItem('currentUser');
//   };

//   return (
//     <AuthContext.Provider
//       value={{
//         authenticated,
//         setAuthenticated,
//         currentUser,
//         setCurrentUser,
//         login,
//         logout,
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// }

// export const useAuth = () => {
//   return useContext(AuthContext);
// };

import React, { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();

export default function AuthContextProvider({ children }) {
  const [authenticated, setAuthenticated] = useState(() => {
    const storedAuth = JSON.parse(localStorage.getItem("authenticated"));
    return storedAuth || false;
  });

  const [currentUser, setCurrentUser] = useState(() => {
    return JSON.parse(localStorage.getItem("currentUser")) || null;
  });

  useEffect(() => {
    // Sync authentication and user state to localStorage on changes
    localStorage.setItem("authenticated", JSON.stringify(authenticated));
    localStorage.setItem("currentUser", JSON.stringify(currentUser));
  }, [authenticated, currentUser]);
 
  

  const login = (user) => {
    setAuthenticated(true);
    setCurrentUser(user);
  };

  const logout = () => {
    setTimeout(() => {
      setAuthenticated(false);
      setCurrentUser(null);
    },0);
    // localStorage.removeItem("authenticated");
    // localStorage.removeItem("currentUser");
    window.open("https://www.egtech.in/", '_self');
    sessionStorage.clear();
    localStorage.clear()
  };

  return (
    <AuthContext.Provider
      value={{
        authenticated,
        setAuthenticated,
        currentUser,
        setCurrentUser,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  return useContext(AuthContext);
};
